import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import router from '../../versa/router.js';
import { notify, ask } from '../../versa/msgbox.js';
import view from '../views/receipt-types.js';
import form from '../forms/receipt-types.js';

const receiptTypes = function ()
{
	const rt_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(e => notify(e)));
		},
		async queryData(query)
		{
			return await api.call(api.list_receipt_types, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_receipt_type, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			const _record = {
				code: String(data.code || '').trim(),
				description: String(data.description || '').trim(),
			};
			if (old_data)
				return await api.call(api.update_receipt_type, data.company_id, data.id, _record);
			return await api.call(api.insert_receipt_type, data.company_id, _record);
		},
		async deleteSelected()
		{
			const ids = await this.getSelectedIds(['company_id', 'id']);
			if (!ids.length)
				return notify('Selecione ao menos um registro.', 'Tipos de recebimento');
			ask(
				`Excluir ${ids.length} tipo(s)? Só é possível excluir tipos sem pedidos de entrada vinculados.`,
				'Excluir',
				async (answer) =>
				{
					if (answer !== 'Y') return;
					for (const [company_id, id] of ids)
					{
						const resp = await api.call(api.delete_receipt_type, company_id, id);
						if (resp === undefined) return;
					}
					this.reloadPage();
				}
			);
		},
	});

	router.set('#receipt-type-delete', rt_crud.deleteSelected.bind(rt_crud));

	const fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Id', types: [], placeholder: '', title: 'Identificador' },
		{ index: 3, field: 'code', label: 'Código', types: [], placeholder: '', title: 'Código' },
		{ index: 4, field: 'description', label: 'Descrição', types: [], placeholder: '', title: 'Descrição' },
	];

	const operations = [
		{ hash: '#receipt-type-delete', label: 'Excluir' },
	];

	rt_crud.run(
		'receipt_types',
		'Tipos&nbsp;de&nbsp;Recebimento',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		operations
	);
};

export default receiptTypes;
